import { useQuery } from '@tanstack/react-query';

import { getSelectedLabels as getSelectedLabelsFn } from './service';

export const useSelectedLabelsQuery = (eventId, token) =>
  useQuery({
    queryKey: ['event', eventId, 'labels', 'selected'],
    queryFn: () => getSelectedLabelsFn(eventId, token),
  });
